import React, { Fragment, useState, useEffect } from 'react';
import {FormControl , TextField, Grid , Box, Card, CardContent , Typography,CardActions,Button } from '@mui/material/';


import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Autorize from '../../components/ui/autorize';
import Officer from '../../components/reports/officer';

//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function Reports() {

    
    const [errorAxios, setErrorAxios] = useState("false");
    const [autorize, setAutorize] = useState("false");

    const [dateDebut, setDateDebut] = useState("");
    const [dateDebutTmp, setDateDebutTmp] = useState("");
  

    const [clublist, setList] = useState("");
    
    const [value, setValue] = React.useState(new Date());
    const [selectedDate, handleDateChange] = useState(new Date());
    const handleChange = (newValue) => {
      setValue(newValue);
    };

     
  const handleChangeDebut = (newValue) => {
    setDateDebutTmp(newValue);
  };
  


    
  useEffect(() => {

        //if(!dateDebutTmp) {
           // setDateDebutTmp(myear);
           // setDateDebut(dateDebutTmp);       
        //}

      
   }, [dateDebutTmp]);
   

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
    
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
    
       // return [year, month, day].join('-');
      
       return year;
    }

    function StartRecherche()    
    {
        setDateDebut(formatDate(dateDebutTmp));
       
    }

    
    function mainHtml()
    {

        if(autorize)
        {
            return (<div>
                    
                 <div style={{  width: '90%', margin: '3%' }}>
                     <Typography variant="h4" gutterBottom>
                        Rapport des officiers
                       </Typography>
                    <Grid container direction="row" >
                        <Grid item xs={1} container direction="row" > 
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='fr'> 

                            <DatePicker id="MyYear"
                                views={['year']}
                                label="Année"
                                inputFormat="YYYY"
                                value={dateDebutTmp}
                                onChange={handleChangeDebut}
                                renderInput={(params) => <TextField {...params} />}
                                />

                            </LocalizationProvider>  
                            </Grid>
                      
                            <Button onClick={StartRecherche} variant="containedFifth">Recherche</Button>            
                    </Grid>
                              
                   


                    <Officer key="sdsgdgdfadsad" MyAnnee={dateDebut} />
                    
                    

                  </div>



                    </div>);
        }
        else
            return "";

    }
  
    const callbackAutoriser = (index) => { // the callback. Use a better name      
      setAutorize(index);     
    };    


    return (

        <div>
        <Autorize axiosError={errorAxios} callBackAutoriser={callbackAutoriser}/>

            {mainHtml()}
            
        </div>
     

            
     );
   
};

export default Reports;